import Crud from '../views/Area/Crud'
import Entity from '../views/Area/Add'

let routes = {
    path: '/areas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/areas/add',
            name: 'NewArea',
            component: Entity,
            meta: {
                pageTitle: 'Area',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/areas'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/areas/edit/:id?',
            name: 'EditArea',
            component: Entity,
            meta: {
                pageTitle: 'Area',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/areas'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/areas',
            name: 'list-areas',
            component: Crud,
            meta: {
                pageTitle: 'Area',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
